// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1fY8D","location":"Header_location__wCei4"};